import { Typography } from "@p0security/ui";
import { CSSProperties } from "react";

const SECTION_LEVEL = 3;

export const GrayTitle: React.FC<{
  title: JSX.Element | string;
  style?: CSSProperties;
}> = ({ title, style }) => {
  return (
    <Typography.Title
      className="[&.ant-typography]:mt-0! [&.ant-typography]:mb-[0.5em]! [&.ant-typography]:text-p0-neutral-50!"
      ellipsis={{ rows: 1 }}
      level={SECTION_LEVEL}
      /* eslint-disable-line react/forbid-component-props */ style={{
        ...(style || {}),
      }}
    >
      {title}
    </Typography.Title>
  );
};
